// @ts-nocheck
import { IterableToArray, Keys } from "@pdfking/tfunc"
import base from "./base"

export default store => {
  return base(store, {
    methods: {
      open_files: store.open,
      open_folders: file_ids =>
        Promise.all(file_ids.map(s => store.startswith(s).then(Keys)))
          .then(a => IterableToArray(...a))
          .then(store.open),
    },
  })
}
